import React, { Fragment } from "react";
import { motion } from "framer-motion";
import dotoodVilAjillagaa from "../../api/dotood-surgalt";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Mcc from "../../components/mcc/Mcc";
import { Link } from "react-router-dom";

const DotoodSurgaltPage = ({ isDark, onToggleDark }) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <motion.div
        intial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Header isDark={isDark} hclass={"header--styleFour"} />
        <main className="main">
          <PageTitle
            pageTitle={"Дотоод үйл ажиллагаа"}
            pagesub={"дотоод үйл ажиллагаа"}
            tolink={"#surgalt"}
          />
          <section className="events pt-70 pb-20" id="surgalt">
            <div className="container">
              <div className="row">
                <Mcc />
                {dotoodVilAjillagaa
                  .map((events, et) => (
                    <div className="col-10 mx-auto mb-30" key={et}>
                      <div className="eventsBlock">
                        <figure className="eventsBlock__thumb">
                          <Link
                            onClick={ClickHandler}
                            to={`/dotood-ua/${events.slug}`}
                            className="eventsBlock__thumb__link"
                          >
                            <img
                              src={events.img1}
                              alt="mcc"
                              className="eventsBlock__thumb__image"
                            />
                          </Link>
                        </figure>
                        <div className="eventsBlock__content">
                          <h3 className="eventsBlock__heading text-uppercase">
                            <Link
                              onClick={ClickHandler}
                              to={`/dotood-ua/${events.slug}`}
                            >
                              {events.title}
                            </Link>
                          </h3>
                          <div className="eventsBlock__meta">
                            <ul>
                              <li>
                                <span className="eventsBlock__meta__title">
                                  Онцлог
                                </span>
                                <span className="eventsBlock__meta__text">
                                  {events.features}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <p className="eventsBlock__text">
                            {events.description.slice(0, 60) + "....."}
                          </p>
                          <Link
                            onClick={ClickHandler}
                            to={`/dotood-ua/${events.slug}`}
                            className="eventsBlock__detailsLink"
                          >
                            Дэлгэрэнгүй
                            <svg
                              width="81"
                              height="12"
                              viewBox="0 0 81 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M60.5303 6.53033C60.8232 6.23744 60.8232 5.76256 60.5303 5.46967L55.7574 0.696699C55.4645 0.403806 54.9896 0.403806 54.6967 0.696699C54.4038 0.989593 54.4038 1.46447 54.6967 1.75736L58.9393 6L54.6967 10.2426C54.4038 10.5355 54.4038 11.0104 54.6967 11.3033C54.9896 11.5962 55.4645 11.5962 55.7574 11.3033L60.5303 6.53033ZM0 6.75H60V5.25H0V6.75Z"
                                fill="#0D0D0D"
                              />
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                  .reverse()}
                <Mcc />
              </div>
            </div>
          </section>
        </main>
        <Footer isDark={isDark} onToggleDark={onToggleDark} />
        <Scrollbar />
      </motion.div>
    </Fragment>
  );
};

export default DotoodSurgaltPage;

// import React, { Fragment, useEffect, useState } from "react";
// import { motion } from "framer-motion";
// import { supabase } from "../../supabaseClient";
// import Header from "../../components/header/Header";
// import PageTitle from "../../components/pagetitle/PageTitle";
// import Scrollbar from "../../components/scrollbar/scrollbar";
// import Footer from "../../components/footer/Footer";
// import Mcc from "../../components/mcc/Mcc";
// import { Link } from "react-router-dom";

// const DotoodSurgaltPage = ({ isDark, onToggleDark }) => {
//   const [events, setEvents] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const ClickHandler = () => {
//     window.scrollTo(10, 0);
//   };

//   useEffect(() => {
//     const fetchEvents = async () => {
//       try {
//         // 1️⃣ JSON-д signed URL авах
//         const { data: signed, error: urlError } = await supabase.storage
//           .from("assets-backet") // bucket нэрээ яг шалгаарай!
//           .createSignedUrl("data/dotoodVilAjillagaa.json", 300);

//         if (urlError) throw urlError;

//         // 2️⃣ JSON татах
//         const res = await fetch(signed.signedUrl);
//         if (!res.ok) throw new Error("JSON татаж чадсангүй");

//         const json = await res.json();

//         // 3️⃣ Зураг бүрийг signed URL болгох
//         const updated = await Promise.all(
//           json.map(async (item) => {
//             const imgKeys = ["img1", "img2", "img3"];
//             for (let key of imgKeys) {
//               if (item[key]) {
//                 const { data: imgSigned, error: imgError } =
//                   await supabase.storage
//                     .from("assets-backet")
//                     .createSignedUrl(item[key], 300);
//                 if (!imgError) {
//                   item[key] = imgSigned.signedUrl;
//                 }
//               }
//             }
//             return item;
//           })
//         );

//         setEvents(updated);
//       } catch (err) {
//         console.error("Алдаа:", err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchEvents();
//   }, []);

//   return (
//     <Fragment>
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >
//         <Header isDark={isDark} hclass={"header--styleFour"} />
//         <main className="main">
//           <PageTitle
//             pageTitle={"Дотоод үйл ажиллагаа"}
//             pagesub={"дотоод үйл ажиллагаа"}
//             tolink={"#surgalt"}
//           />

//           <section className="events pt-70 pb-20" id="surgalt">
//             <div className="container">
//               <div className="row">
//                 <Mcc />
//                 {loading ? (
//                   <p className="text-center">Уншиж байна...</p>
//                 ) : (
//                   events
//                     .map((event, idx) => (
//                       <div className="col-10 mx-auto mb-30" key={idx}>
//                         <div className="eventsBlock">
//                           <figure className="eventsBlock__thumb">
//                             <Link
//                               onClick={ClickHandler}
//                               to={`/dotood-ua/${event.slug}`}
//                               className="eventsBlock__thumb__link"
//                             >
//                               <img
//                                 src={event.img1}
//                                 alt="mcc"
//                                 className="eventsBlock__thumb__image"
//                               />
//                             </Link>
//                           </figure>
//                           <div className="eventsBlock__content">
//                             <h3 className="eventsBlock__heading text-uppercase">
//                               <Link
//                                 onClick={ClickHandler}
//                                 to={`/dotood-ua/${event.slug}`}
//                               >
//                                 {event.title}
//                               </Link>
//                             </h3>
//                             <div className="eventsBlock__meta">
//                               <ul>
//                                 <li>
//                                   <span className="eventsBlock__meta__title">
//                                     Онцлог
//                                   </span>
//                                   <span className="eventsBlock__meta__text">
//                                     {event.features}
//                                   </span>
//                                 </li>
//                               </ul>
//                             </div>
//                             <p className="eventsBlock__text">
//                               {event.description.slice(0, 60) + "....."}
//                             </p>
//                             <Link
//                               onClick={ClickHandler}
//                               to={`/dotood-ua/${event.slug}`}
//                               className="eventsBlock__detailsLink"
//                             >
//                               Дэлгэрэнгүй
//                               <svg
//                                 width="81"
//                                 height="12"
//                                 viewBox="0 0 81 12"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                               >
//                                 <path
//                                   d="M60.5303 6.53033C60.8232 6.23744 60.8232 5.76256 60.5303 5.46967L55.7574 0.696699C55.4645 0.403806 54.9896 0.403806 54.6967 0.696699C54.4038 0.989593 54.4038 1.46447 54.6967 1.75736L58.9393 6L54.6967 10.2426C54.4038 10.5355 54.4038 11.0104 54.6967 11.3033C54.9896 11.5962 55.4645 11.5962 55.7574 11.3033L60.5303 6.53033ZM0 6.75H60V5.25H0V6.75Z"
//                                   fill="#0D0D0D"
//                                 />
//                               </svg>
//                             </Link>
//                           </div>
//                         </div>
//                       </div>
//                     ))
//                     .reverse()
//                 )}
//                 <Mcc />
//               </div>
//             </div>
//           </section>
//         </main>
//         <Footer isDark={isDark} onToggleDark={onToggleDark} />
//         <Scrollbar />
//       </motion.div>
//     </Fragment>
//   );
// };

// export default DotoodSurgaltPage;
